<div
  class="interface-control__time-input__container"
  [ngClass]="{'interface-control__time-input__container--valid': data.state === 0 && !data.locked && data.showValidation,
                'interface-control__time-input__container--invalid': data.state === 1 && !data.locked && data.showValidation,
                'interface-control__time-input__container--active': data.state === 2 && !data.locked && data.showValidation,
                'interface-control__time-input__container--inactive': data.state === 3 && !data.locked && data.showValidation,
                'interface-control__time-input__container--locked': data.locked && data.showValidation}"
>
  <label
    class="interface-control__time-input__label"
    [ngClass]="{'interface-control__time-input__label--unlocked': !data.locked,
                    'interface-control__time-input__label--locked': data.locked}"
    for="time-from-to"
    >{{data.label}}
  </label>
  <div fxLayout="row" fxLayoutGap="0px">
    <bfx-time-edit
      #inputMask
      inputId="time-from-to"
      [(ngModel)]="data.timeValue"
      (ngModelChange)="onBlur($event)"
      (onBlur)="onBlur($event)"
      (onFocus)="onFocus($event)"
      [disabled]="data.locked"
      autoFocus="true"
      class="interface-control__time-input__input"
      [ngClass]="{
                'interface-control__time-input__input--valid': data.state === 0 && !data.locked,
                'interface-control__time-input__input--invalid': data.state === 1 && !data.locked,
                'interface-control__time-input__input--active': data.state === 2 && !data.locked,
                'interface-control__time-input__input--inactive': data.state === 3 && !data.locked,
                'interface-control__time-input__input--locked': data.locked}"
    >
    </bfx-time-edit>
    <bfx-autoComplete
      #timezoneDropdown
      *ngIf="nativeDropdown"
      size="sm"
      [(ngModel)]="data.timezoneValue"
      [suggestions]="data.timezoneDatasetFiltered"
      (completeMethod)="filterTimezones($event)"
      [disabled]="data.locked"
      (onFocus)="onFocus($event)"
      (onBlur)="onBlur($event)"
      (ngModelChange)="onBlur($event)"
      dataKey="dataItem"
      field="label"
      [autoHighlight]="true"
      [skipSorting]="true"
      delay="4"
      [maxlength]="4"
      [skipBlur]="true"
      nativeDesktopDropdown="bfxTimeInput"
      target="bfxTimeInput"
      [state]="data.state"
      [dropdown]="true"
      [minLength]="0"
      class="interface-control__time-input__dropdown"
      [ngClass]="{
                'interface-control__time-input__dropdown--valid': data.state === 0 && !data.locked,
                'interface-control__time-input__dropdown--invalid': data.state === 1 && !data.locked,
                'interface-control__time-input__dropdown--active': data.state === 2 && !data.locked,
                'interface-control__time-input__dropdown--inactive': data.state === 3 && !data.locked,
                'interface-control__time-input__dropdown--locked': data.locked}"
    >
      <ng-template let-dataItem pTemplate="item">
        <div class="ui-helper-clearfix">
          <div>{{dataItem.label}}</div>
        </div>
      </ng-template>
    </bfx-autoComplete>
    <bfx-autoComplete
      #timezoneDropdown
      *ngIf="!nativeDropdown"
      appendTo="body"
      [(ngModel)]="data.timezoneValue"
      [suggestions]="data.timezoneDatasetFiltered"
      (completeMethod)="filterTimezones($event)"
      [disabled]="data.locked"
      (onFocus)="onFocus($event)"
      (onBlur)="onBlur($event)"
      (ngModelChange)="onBlur($event)"
      dataKey="dataItem"
      field="label"
      [autoHighlight]="true"
      [skipSorting]="true"
      delay="4"
      [maxlength]="4"
      [skipBlur]="true"
      [state]="data.state"
      [dropdown]="true"
      [minLength]="0"
      size="sm"
      class="interface-control__time-input__dropdown"
      dropdownMenuClass="interface-control__time-input__dropdown"
      [ngClass]="{
                'interface-control__time-input__dropdown--valid': data.state === 0 && !data.locked,
                'interface-control__time-input__dropdown--invalid': data.state === 1 && !data.locked,
                'interface-control__time-input__dropdown--active': data.state === 2 && !data.locked,
                'interface-control__time-input__dropdown--inactive': data.state === 3 && !data.locked,
                'interface-control__time-input__dropdown--locked': data.locked}"
    >
      <ng-template let-dataItem pTemplate="item">
        <div class="ui-helper-clearfix">
          <div>{{dataItem.label}}</div>
        </div>
      </ng-template>
    </bfx-autoComplete>
  </div>
</div>
